import type { MRT_ColumnDef } from "mantine-react-table-open";
import { backendDateOrDateTimeToLuxonDateTime } from "../../../../../utils/dates/backendDateOrDateTimeToLuxonDateTime";
import { DATE_DISPLAY_FORMAT } from "../../../../../utils/dates/dates.constants";
import type { PPAContract } from "../../PPAContractPage.types";

export function getEndColumn(): MRT_ColumnDef<PPAContract> {
  return {
    accessorKey: "next_end_date",
    accessorFn: (row) =>
      backendDateOrDateTimeToLuxonDateTime(row.next_end_date).toJSDate(),
    header: "Gültig bis",
    size: 140,
    Cell: ({ row }) =>
      backendDateOrDateTimeToLuxonDateTime(row.original.next_end_date).toFormat(
        DATE_DISPLAY_FORMAT
      ),
    filterVariant: "date-range"
  };
}
